import { render } from "./EvmTokenInfo.vue?vue&type=template&id=95b37fd8"
import script from "./EvmTokenInfo.vue?vue&type=script&lang=js"
export * from "./EvmTokenInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__